<template>
	<section id="contact" class="contact subpage">
		<div class="head">
			<div class="wrapper">
				<div class="head__left">
					<h2 class="head__title">contact</h2>
				</div>
				<div class="head__right">
					<p>서울 구로구 경인로 482 생각공장 구로 E704~E706호</p>
					<p>
						<b>TEL. 02-2677-0212</b>
						<b>FAX. 02-2677-0218</b>
					</p>
				</div>
			</div>
		</div>
		<article class="request">
			<div class="wrapper">
				<div class="request__context">
					<h3 class="request__title">컨설팅의뢰 및 문의사항</h3>
					<a href="mailto:master@netcomm.co.kr" class="request__link">master@netcomm.co.kr</a>
				</div>
				<img
					src="@/assets/images/contact/contact_image0.jpg"
					alt=""
					class="request__image"
				/>
			</div>
		</article>
		<article class="directions">
			<div class="wrapper">
				<h3 class="hidden">오시는 길</h3>
				<div class="directions__transport directions__transport--subway">
					<p class="directions__title"><strong>Subway</strong></p>
					<ul class="directions__list">
						<li class="directions__item">
							<i class="directions__icon" style="background-color: #0052A4">1</i>
							<span>구일역 1번 출구 도보 6분</span>
						</li>
					</ul>
				</div>
				<div class="directions__transport directions__transport--bus">
					<p class="directions__title">
						<strong>BUS</strong>구일역. 제일제당(중) (17006)
					</p>
					<ul class="directions__list">
						<li class="directions__item">
							<i class="directions__icon" style="background-color: #0068b7">B</i>
							<span>간선버스 160, 600, 660, 662</span>
						</li>
						<li class="directions__item">
							<i class="directions__icon" style="background-color: #53b332">B</i>
							<span>지선버스 5626, 5712, 6511, 6515, 6637, 6640B, 6713</span>
						</li>
						<!-- <li class="directions__item">
                            <i class="directions__icon" style="background-color: #5bb025">B</i>
							<span>마을버스 구로13</span>
						</li> -->
                        <li class="directions__item">
                            <i class="directions__icon" style="background-color: #EE2737">B</i>
                            <span>직행좌석버스 5200</span>
                        </li>
                        <li class="directions__item">
                            <i class="directions__icon" style="background-color: #0085CA">B</i>
                            <span>일반좌석버스 301 320</span>
                        </li>
						<!-- <li class="directions__item">
							<i class="directions__icon" style="background-color: #009775">B</i>
							<span>경기시내버스 10, 11-1, 11-2, 83, 88, 530</span>
						</li> -->
					</ul>
				</div>
			</div>
		</article>
		<article class="map">
			<h3 class="hidden">지도</h3>
			<div id="map"></div>
		</article>
	</section>
</template>

<script>
export default {
	name: "Contact",
	created: function() {
		setTimeout(() => {
			document.querySelector(".request__image").classList.add("animate")
		}, 500);
	},
	mounted() {
		window.kakao && window.kakao.maps
			? this.initMap()
			: this.addKakaoMapScript();
	},
	methods: {
		addKakaoMapScript() {
			const script = document.createElement("script");
			/* global kakao */
			script.onload = () => kakao.maps.load(this.initMap);
			script.src =
				"http://dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=e48aa8de7d9cb606ec64fb561804e1ac";
			document.head.appendChild(script);
		},
		initMap() {
			var container = document.getElementById("map"); //지도를 담을 영역의 DOM 레퍼런스
			var options = {
				//지도를 생성할 때 필요한 기본 옵션
				center: new kakao.maps.LatLng(37.498288, 126.872659), //지도의 중심좌표.
				level: 3, //지도의 레벨(확대, 축소 정도)
			};

			var map = new kakao.maps.Map(container, options); //지도 생성 및 객체 리턴

			// 마커가 표시될 위치입니다
			var markerPosition = new kakao.maps.LatLng(37.498288, 126.872659);

			// 마커를 생성합니다
			var marker = new kakao.maps.Marker({
				position: markerPosition,
			});

			// 마커가 지도 위에 표시되도록 설정합니다
			marker.setMap(map);
		},
	},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/css/scss/contact";
</style>